var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"usage-counter"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("icon"),(!_vm.maxAmount)?_c('span',[_vm._v(_vm._s(_vm.usageAmount))]):_c('span',{staticClass:"counter",class:{'text-danger': _vm.danger}},[_vm._v(_vm._s(_vm.usageAmount)+" / "+_vm._s(_vm.maxAmount))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }